import React from 'react'

export interface IUserClickContext {
  clicked: boolean
  setClicked: (v: boolean) => void
}

const Ctx = React.createContext<IUserClickContext>({
  clicked: false,
  setClicked: (v) => null
})

export default Ctx
